import type { SupportedLanguage } from './index'

/**
 * Localized route paths for IT/EN.
 * Each key maps to a route name with per-language path segments.
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
  },
  about: {
    it: 'chi-siamo',
    en: 'about-us',
  },
  products: {
    it: 'prodotti',
    en: 'products',
  },
  sectors: {
    it: 'settori',
    en: 'sectors',
  },
  sectorPolice: {
    it: 'settori/polizia-locale',
    en: 'sectors/local-police',
  },
  sectorLawEnforcement: {
    it: 'settori/forze-ordine',
    en: 'sectors/law-enforcement',
  },
  sectorPortsAirports: {
    it: 'settori/porti-aeroporti',
    en: 'sectors/ports-airports',
  },
  sectorParking: {
    it: 'settori/parking',
    en: 'sectors/parking',
  },
  academy: {
    it: 'academy',
    en: 'academy',
  },

  contacts: {
    it: 'contatti',
    en: 'contacts',
  },
  login: {
    it: 'accedi',
    en: 'login',
  },
  register: {
    it: 'registrati',
    en: 'register',
  },
  privacy: {
    it: 'privacy-policy',
    en: 'privacy-policy',
  },
  cookie: {
    it: 'cookie-policy',
    en: 'cookie-policy',
  },
  accessibility: {
    it: 'dichiarazione-di-accessibilita',
    en: 'accessibility-statement',
  },
  vdp: {
    it: 'vulnerability-disclosure-policy',
    en: 'vulnerability-disclosure-policy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
